import { Button } from '@heroui/react';
import React from 'react';
import { FiSun, FiMoon } from 'react-icons/fi';

import { useTheme } from '../../contexts/ThemeContext';

interface ThemeToggleProps {
  className?: string;
}

export const ThemeToggle: React.FC<ThemeToggleProps> = ({ className }) => {
  const { theme, toggleTheme } = useTheme();

  return (
    <Button
      isIconOnly
      variant="light"
      onPress={toggleTheme}
      aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
      className={`hover:bg-gray-100 dark:hover:bg-gray-800 transition-all border border-transparent hover:border-gray-200 dark:hover:border-gray-600 text-gray-700 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white ${
        className || ''
      }`}
      size="lg"
    >
      {theme === 'light' ? (
        <FiMoon size={20} className="text-gray-700" />
      ) : (
        <FiSun size={20} className="text-gray-300" />
      )}
    </Button>
  );
};
